
interface TelemetryData {
  timestamp: string;
  smartMeters: {
    online: number;
    warning: number;
    critical: number;
    offline: number;
    totalReadings: number;
    averagePower?: number;
    averageConsumption?: number;
  };
  gateways: {
    online: number;
    warning: number;
    critical: number;
    offline: number;
    averageLatency: number;
    dataTransferred: number;
  };
}

// Format telemetry data for charts
export const formatChartData = (telemetryData: TelemetryData[]) => {
  return telemetryData.map(item => ({
    name: new Date(item.timestamp).toLocaleDateString(),
    smartMetersOnline: item.smartMeters.online,
    smartMetersWarning: item.smartMeters.warning,
    smartMetersCritical: item.smartMeters.critical,
    smartMetersOffline: item.smartMeters.offline,
    gatewaysOnline: item.gateways.online,
    gatewaysWarning: item.gateways.warning,
    gatewaysCritical: item.gateways.critical,
    gatewaysOffline: item.gateways.offline,
    averagePower: item.smartMeters.averagePower,
    averageConsumption: item.smartMeters.averageConsumption,
    averageLatency: item.gateways.averageLatency,
    dataTransferred: item.gateways.dataTransferred,
    // Total devices by status for summary cards
    totalOnline: item.smartMeters.online + item.gateways.online,
    totalWarning: item.smartMeters.warning + item.gateways.warning,
    totalCritical: item.smartMeters.critical + item.gateways.critical,
    totalOffline: item.smartMeters.offline + item.gateways.offline,
    totalReadings: item.smartMeters.totalReadings
  }));
};

// Get the latest telemetry data
export const getLatestTelemetry = (telemetryData: TelemetryData[]) => {
  return telemetryData.length > 0 ? telemetryData[0] : null;
};

// Export the TelemetryData type
export type { TelemetryData };
